/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { assignMeetDayStudent } from '../fn/meet-day/assign-meet-day-student';
import { AssignMeetDayStudent$Params } from '../fn/meet-day/assign-meet-day-student';
import { confirmAttendance } from '../fn/meet-day/confirm-attendance';
import { ConfirmAttendance$Params } from '../fn/meet-day/confirm-attendance';
import { createAnonymousMeetDayStudent } from '../fn/meet-day/create-anonymous-meet-day-student';
import { CreateAnonymousMeetDayStudent$Params } from '../fn/meet-day/create-anonymous-meet-day-student';
import { createMeetDay } from '../fn/meet-day/create-meet-day';
import { CreateMeetDay$Params } from '../fn/meet-day/create-meet-day';
import { createMeetDayStudent } from '../fn/meet-day/create-meet-day-student';
import { CreateMeetDayStudent$Params } from '../fn/meet-day/create-meet-day-student';
import { deleteMeetDay } from '../fn/meet-day/delete-meet-day';
import { DeleteMeetDay$Params } from '../fn/meet-day/delete-meet-day';
import { deleteMeetDayStudent } from '../fn/meet-day/delete-meet-day-student';
import { DeleteMeetDayStudent$Params } from '../fn/meet-day/delete-meet-day-student';
import { exportMeetDayStudents } from '../fn/meet-day/export-meet-day-students';
import { ExportMeetDayStudents$Params } from '../fn/meet-day/export-meet-day-students';
import { File } from '../models/file';
import { getMeetDay } from '../fn/meet-day/get-meet-day';
import { GetMeetDay$Params } from '../fn/meet-day/get-meet-day';
import { getMeetDays } from '../fn/meet-day/get-meet-days';
import { GetMeetDays$Params } from '../fn/meet-day/get-meet-days';
import { getMeetDayStudent } from '../fn/meet-day/get-meet-day-student';
import { GetMeetDayStudent$Params } from '../fn/meet-day/get-meet-day-student';
import { getMeetDayStudentForCurrentUser } from '../fn/meet-day/get-meet-day-student-for-current-user';
import { GetMeetDayStudentForCurrentUser$Params } from '../fn/meet-day/get-meet-day-student-for-current-user';
import { getMeetDayStudents } from '../fn/meet-day/get-meet-day-students';
import { GetMeetDayStudents$Params } from '../fn/meet-day/get-meet-day-students';
import { MeetDay } from '../models/meet-day';
import { MeetDayCompany } from '../models/meet-day-company';
import { meetdayMeetDayIdStudentIdTop3CompanyIdDelete } from '../fn/meet-day/meetday-meet-day-id-student-id-top-3-company-id-delete';
import { MeetdayMeetDayIdStudentIdTop3CompanyIdDelete$Params } from '../fn/meet-day/meetday-meet-day-id-student-id-top-3-company-id-delete';
import { meetdayMeetDayIdStudentIdTop3CompanyIdPost } from '../fn/meet-day/meetday-meet-day-id-student-id-top-3-company-id-post';
import { MeetdayMeetDayIdStudentIdTop3CompanyIdPost$Params } from '../fn/meet-day/meetday-meet-day-id-student-id-top-3-company-id-post';
import { meetdayMeetDayIdStudentIdTop5CompanyIdDelete } from '../fn/meet-day/meetday-meet-day-id-student-id-top-5-company-id-delete';
import { MeetdayMeetDayIdStudentIdTop5CompanyIdDelete$Params } from '../fn/meet-day/meetday-meet-day-id-student-id-top-5-company-id-delete';
import { meetdayMeetDayIdStudentIdTop5CompanyIdPost } from '../fn/meet-day/meetday-meet-day-id-student-id-top-5-company-id-post';
import { MeetdayMeetDayIdStudentIdTop5CompanyIdPost$Params } from '../fn/meet-day/meetday-meet-day-id-student-id-top-5-company-id-post';
import { MeetDayPagedData } from '../models/meet-day-paged-data';
import { MeetDayStudent } from '../models/meet-day-student';
import { MeetDayStudentPagedData } from '../models/meet-day-student-paged-data';
import { registerCompanyForMeetDay } from '../fn/meet-day/register-company-for-meet-day';
import { RegisterCompanyForMeetDay$Params } from '../fn/meet-day/register-company-for-meet-day';
import { unregisterCompanyForMeetDay } from '../fn/meet-day/unregister-company-for-meet-day';
import { UnregisterCompanyForMeetDay$Params } from '../fn/meet-day/unregister-company-for-meet-day';
import { updateMeetDay } from '../fn/meet-day/update-meet-day';
import { UpdateMeetDay$Params } from '../fn/meet-day/update-meet-day';
import { updateMeetDayStudent } from '../fn/meet-day/update-meet-day-student';
import { UpdateMeetDayStudent$Params } from '../fn/meet-day/update-meet-day-student';
import { updateStudentCapForCompany } from '../fn/meet-day/update-student-cap-for-company';
import { UpdateStudentCapForCompany$Params } from '../fn/meet-day/update-student-cap-for-company';

@Injectable({ providedIn: 'root' })
export class MeetDayService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getMeetDays()` */
  static readonly GetMeetDaysPath = '/meetday';

  /**
   * Gets all planned meet days.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMeetDays()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMeetDays$Response(params?: GetMeetDays$Params, context?: HttpContext): Observable<StrictHttpResponse<MeetDayPagedData>> {
    const obs = getMeetDays(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets all planned meet days.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMeetDays$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMeetDays(params?: GetMeetDays$Params, context?: HttpContext): Observable<MeetDayPagedData> {
    const resp = this.getMeetDays$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MeetDayPagedData>): MeetDayPagedData => r.body)
    );
  }

  /** Path part for operation `createMeetDay()` */
  static readonly CreateMeetDayPath = '/meetday';

  /**
   * Creates a new planned meet day [policies: Regioprojectleider].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createMeetDay()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createMeetDay$Response(params?: CreateMeetDay$Params, context?: HttpContext): Observable<StrictHttpResponse<MeetDay>> {
    const obs = createMeetDay(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Creates a new planned meet day [policies: Regioprojectleider].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createMeetDay$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createMeetDay(params?: CreateMeetDay$Params, context?: HttpContext): Observable<MeetDay> {
    const resp = this.createMeetDay$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MeetDay>): MeetDay => r.body)
    );
  }

  /** Path part for operation `getMeetDay()` */
  static readonly GetMeetDayPath = '/meetday/{id}';

  /**
   * Gets the specified planned meet day.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMeetDay()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMeetDay$Response(params: GetMeetDay$Params, context?: HttpContext): Observable<StrictHttpResponse<MeetDay>> {
    const obs = getMeetDay(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets the specified planned meet day.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMeetDay$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMeetDay(params: GetMeetDay$Params, context?: HttpContext): Observable<MeetDay> {
    const resp = this.getMeetDay$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MeetDay>): MeetDay => r.body)
    );
  }

  /** Path part for operation `updateMeetDay()` */
  static readonly UpdateMeetDayPath = '/meetday/{id}';

  /**
   * Updates the specified planned meet day [policies: Regioprojectleider].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateMeetDay()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateMeetDay$Response(params: UpdateMeetDay$Params, context?: HttpContext): Observable<StrictHttpResponse<MeetDay>> {
    const obs = updateMeetDay(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates the specified planned meet day [policies: Regioprojectleider].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateMeetDay$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateMeetDay(params: UpdateMeetDay$Params, context?: HttpContext): Observable<MeetDay> {
    const resp = this.updateMeetDay$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MeetDay>): MeetDay => r.body)
    );
  }

  /** Path part for operation `deleteMeetDay()` */
  static readonly DeleteMeetDayPath = '/meetday/{id}';

  /**
   * Deletes the specified planned meet day [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteMeetDay()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteMeetDay$Response(params: DeleteMeetDay$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteMeetDay(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Deletes the specified planned meet day [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteMeetDay$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteMeetDay(params: DeleteMeetDay$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteMeetDay$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `registerCompanyForMeetDay()` */
  static readonly RegisterCompanyForMeetDayPath = '/meetday/{id}/company/register';

  /**
   * Registers the specified company for the selected meet day [policies: Company].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registerCompanyForMeetDay()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  registerCompanyForMeetDay$Response(params: RegisterCompanyForMeetDay$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = registerCompanyForMeetDay(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Registers the specified company for the selected meet day [policies: Company].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `registerCompanyForMeetDay$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  registerCompanyForMeetDay(params: RegisterCompanyForMeetDay$Params, context?: HttpContext): Observable<void> {
    const resp = this.registerCompanyForMeetDay$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateStudentCapForCompany()` */
  static readonly UpdateStudentCapForCompanyPath = '/meetday/{id}/company/updatestudentcap';

  /**
   * [policies: Company].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateStudentCapForCompany()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateStudentCapForCompany$Response(params: UpdateStudentCapForCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<MeetDayCompany>> {
    const obs = updateStudentCapForCompany(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * [policies: Company].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateStudentCapForCompany$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateStudentCapForCompany(params: UpdateStudentCapForCompany$Params, context?: HttpContext): Observable<MeetDayCompany> {
    const resp = this.updateStudentCapForCompany$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MeetDayCompany>): MeetDayCompany => r.body)
    );
  }

  /** Path part for operation `unregisterCompanyForMeetDay()` */
  static readonly UnregisterCompanyForMeetDayPath = '/meetday/{id}/company/unregister';

  /**
   * Un-registers the specified company [policies: Company].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `unregisterCompanyForMeetDay()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  unregisterCompanyForMeetDay$Response(params: UnregisterCompanyForMeetDay$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = unregisterCompanyForMeetDay(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Un-registers the specified company [policies: Company].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `unregisterCompanyForMeetDay$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  unregisterCompanyForMeetDay(params: UnregisterCompanyForMeetDay$Params, context?: HttpContext): Observable<void> {
    const resp = this.unregisterCompanyForMeetDay$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getMeetDayStudents()` */
  static readonly GetMeetDayStudentsPath = '/meetday/{meetDayId}/student';

  /**
   * Gets all registered students for the specified meet day [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMeetDayStudents()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMeetDayStudents$Response(params: GetMeetDayStudents$Params, context?: HttpContext): Observable<StrictHttpResponse<MeetDayStudentPagedData>> {
    const obs = getMeetDayStudents(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets all registered students for the specified meet day [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMeetDayStudents$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMeetDayStudents(params: GetMeetDayStudents$Params, context?: HttpContext): Observable<MeetDayStudentPagedData> {
    const resp = this.getMeetDayStudents$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MeetDayStudentPagedData>): MeetDayStudentPagedData => r.body)
    );
  }

  /** Path part for operation `confirmAttendance()` */
  static readonly ConfirmAttendancePath = '/meetday/{meetDayId}/student';

  /**
   * Confirm the attendance of a student for a meetday. [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `confirmAttendance()` instead.
   *
   * This method doesn't expect any request body.
   */
  confirmAttendance$Response(params: ConfirmAttendance$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = confirmAttendance(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Confirm the attendance of a student for a meetday. [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `confirmAttendance$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  confirmAttendance(params: ConfirmAttendance$Params, context?: HttpContext): Observable<void> {
    const resp = this.confirmAttendance$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createMeetDayStudent()` */
  static readonly CreateMeetDayStudentPath = '/meetday/{meetDayId}/student';

  /**
   * Creates a new registered student, can also be an anonymous user [policies: Student].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createMeetDayStudent()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createMeetDayStudent$Response(params: CreateMeetDayStudent$Params, context?: HttpContext): Observable<StrictHttpResponse<MeetDayStudent>> {
    const obs = createMeetDayStudent(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Creates a new registered student, can also be an anonymous user [policies: Student].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createMeetDayStudent$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createMeetDayStudent(params: CreateMeetDayStudent$Params, context?: HttpContext): Observable<MeetDayStudent> {
    const resp = this.createMeetDayStudent$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MeetDayStudent>): MeetDayStudent => r.body)
    );
  }

  /** Path part for operation `getMeetDayStudent()` */
  static readonly GetMeetDayStudentPath = '/meetday/{meetDayId}/student/{id}';

  /**
   * Gets the specified registered student for the specified meet day [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMeetDayStudent()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMeetDayStudent$Response(params: GetMeetDayStudent$Params, context?: HttpContext): Observable<StrictHttpResponse<MeetDayStudent>> {
    const obs = getMeetDayStudent(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets the specified registered student for the specified meet day [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMeetDayStudent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMeetDayStudent(params: GetMeetDayStudent$Params, context?: HttpContext): Observable<MeetDayStudent> {
    const resp = this.getMeetDayStudent$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MeetDayStudent>): MeetDayStudent => r.body)
    );
  }

  /** Path part for operation `updateMeetDayStudent()` */
  static readonly UpdateMeetDayStudentPath = '/meetday/{meetDayId}/student/{id}';

  /**
   * Updates the specified registered student [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateMeetDayStudent()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateMeetDayStudent$Response(params: UpdateMeetDayStudent$Params, context?: HttpContext): Observable<StrictHttpResponse<MeetDayStudent>> {
    const obs = updateMeetDayStudent(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates the specified registered student [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateMeetDayStudent$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateMeetDayStudent(params: UpdateMeetDayStudent$Params, context?: HttpContext): Observable<MeetDayStudent> {
    const resp = this.updateMeetDayStudent$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MeetDayStudent>): MeetDayStudent => r.body)
    );
  }

  /** Path part for operation `deleteMeetDayStudent()` */
  static readonly DeleteMeetDayStudentPath = '/meetday/{meetDayId}/student/{id}';

  /**
   * Deletes the specified registered student [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteMeetDayStudent()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteMeetDayStudent$Response(params: DeleteMeetDayStudent$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteMeetDayStudent(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Deletes the specified registered student [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteMeetDayStudent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteMeetDayStudent(params: DeleteMeetDayStudent$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteMeetDayStudent$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createAnonymousMeetDayStudent()` */
  static readonly CreateAnonymousMeetDayStudentPath = '/meetday/{meetDayId}/student/anonymous';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAnonymousMeetDayStudent()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createAnonymousMeetDayStudent$Response(params: CreateAnonymousMeetDayStudent$Params, context?: HttpContext): Observable<StrictHttpResponse<MeetDayStudent>> {
    const obs = createAnonymousMeetDayStudent(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createAnonymousMeetDayStudent$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createAnonymousMeetDayStudent(params: CreateAnonymousMeetDayStudent$Params, context?: HttpContext): Observable<MeetDayStudent> {
    const resp = this.createAnonymousMeetDayStudent$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MeetDayStudent>): MeetDayStudent => r.body)
    );
  }

  /** Path part for operation `assignMeetDayStudent()` */
  static readonly AssignMeetDayStudentPath = '/meetday/{meetDayId}/student/assign';

  /**
   * Assigns the student profiles to the specified meetday [policies: Teacher].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `assignMeetDayStudent()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  assignMeetDayStudent$Response(params: AssignMeetDayStudent$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = assignMeetDayStudent(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Assigns the student profiles to the specified meetday [policies: Teacher].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `assignMeetDayStudent$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  assignMeetDayStudent(params: AssignMeetDayStudent$Params, context?: HttpContext): Observable<void> {
    const resp = this.assignMeetDayStudent$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getMeetDayStudentForCurrentUser()` */
  static readonly GetMeetDayStudentForCurrentUserPath = '/meetday/{meetDayId}/student/current';

  /**
   * Gets the MeetDayStudent object for the specified meetday and the current user. [policies: Student].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMeetDayStudentForCurrentUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMeetDayStudentForCurrentUser$Response(params: GetMeetDayStudentForCurrentUser$Params, context?: HttpContext): Observable<StrictHttpResponse<MeetDayStudent>> {
    const obs = getMeetDayStudentForCurrentUser(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets the MeetDayStudent object for the specified meetday and the current user. [policies: Student].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMeetDayStudentForCurrentUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMeetDayStudentForCurrentUser(params: GetMeetDayStudentForCurrentUser$Params, context?: HttpContext): Observable<MeetDayStudent> {
    const resp = this.getMeetDayStudentForCurrentUser$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MeetDayStudent>): MeetDayStudent => r.body)
    );
  }

  /** Path part for operation `meetdayMeetDayIdStudentIdTop3CompanyIdPost()` */
  static readonly MeetdayMeetDayIdStudentIdTop3CompanyIdPostPath = '/meetday/{meetDayId}/student/{id}/top3/{companyId}';

  /**
   * Adds the speficied company to first available spot on the student's meetday top-3. [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetdayMeetDayIdStudentIdTop3CompanyIdPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetdayMeetDayIdStudentIdTop3CompanyIdPost$Response(params: MeetdayMeetDayIdStudentIdTop3CompanyIdPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = meetdayMeetDayIdStudentIdTop3CompanyIdPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Adds the speficied company to first available spot on the student's meetday top-3. [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetdayMeetDayIdStudentIdTop3CompanyIdPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetdayMeetDayIdStudentIdTop3CompanyIdPost(params: MeetdayMeetDayIdStudentIdTop3CompanyIdPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.meetdayMeetDayIdStudentIdTop3CompanyIdPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `meetdayMeetDayIdStudentIdTop3CompanyIdDelete()` */
  static readonly MeetdayMeetDayIdStudentIdTop3CompanyIdDeletePath = '/meetday/{meetDayId}/student/{id}/top3/{companyId}';

  /**
   * Removes the specified company from the student's top-3 [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetdayMeetDayIdStudentIdTop3CompanyIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetdayMeetDayIdStudentIdTop3CompanyIdDelete$Response(params: MeetdayMeetDayIdStudentIdTop3CompanyIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = meetdayMeetDayIdStudentIdTop3CompanyIdDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Removes the specified company from the student's top-3 [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetdayMeetDayIdStudentIdTop3CompanyIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetdayMeetDayIdStudentIdTop3CompanyIdDelete(params: MeetdayMeetDayIdStudentIdTop3CompanyIdDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.meetdayMeetDayIdStudentIdTop3CompanyIdDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `meetdayMeetDayIdStudentIdTop5CompanyIdPost()` */
  static readonly MeetdayMeetDayIdStudentIdTop5CompanyIdPostPath = '/meetday/{meetDayId}/student/{id}/top5/{companyId}';

  /**
   * Adds the speficied company to first available spot on the student's meetday top-5. [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetdayMeetDayIdStudentIdTop5CompanyIdPost()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  meetdayMeetDayIdStudentIdTop5CompanyIdPost$Response(params: MeetdayMeetDayIdStudentIdTop5CompanyIdPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = meetdayMeetDayIdStudentIdTop5CompanyIdPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Adds the speficied company to first available spot on the student's meetday top-5. [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetdayMeetDayIdStudentIdTop5CompanyIdPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  meetdayMeetDayIdStudentIdTop5CompanyIdPost(params: MeetdayMeetDayIdStudentIdTop5CompanyIdPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.meetdayMeetDayIdStudentIdTop5CompanyIdPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `meetdayMeetDayIdStudentIdTop5CompanyIdDelete()` */
  static readonly MeetdayMeetDayIdStudentIdTop5CompanyIdDeletePath = '/meetday/{meetDayId}/student/{id}/top5/{companyId}';

  /**
   * Removes the specified company from the student's top-5 [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetdayMeetDayIdStudentIdTop5CompanyIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  meetdayMeetDayIdStudentIdTop5CompanyIdDelete$Response(params: MeetdayMeetDayIdStudentIdTop5CompanyIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = meetdayMeetDayIdStudentIdTop5CompanyIdDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Removes the specified company from the student's top-5 [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetdayMeetDayIdStudentIdTop5CompanyIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  meetdayMeetDayIdStudentIdTop5CompanyIdDelete(params: MeetdayMeetDayIdStudentIdTop5CompanyIdDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.meetdayMeetDayIdStudentIdTop5CompanyIdDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `exportMeetDayStudents()` */
  static readonly ExportMeetDayStudentsPath = '/meetday/{meetDayId}/student/export';

  /**
   * Export all registered students for the specified meet day in excel format [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportMeetDayStudents()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportMeetDayStudents$Response(params: ExportMeetDayStudents$Params, context?: HttpContext): Observable<StrictHttpResponse<File>> {
    const obs = exportMeetDayStudents(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Export all registered students for the specified meet day in excel format [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportMeetDayStudents$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportMeetDayStudents(params: ExportMeetDayStudents$Params, context?: HttpContext): Observable<File> {
    const resp = this.exportMeetDayStudents$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<File>): File => r.body)
    );
  }

}
